<script>
import('@homepage/helpers/webRtc/adapter');
import {setup} from '@homepage/helpers/webRtc/app.js';

export default {
	name: 'OldPixelStreamer',
	props: {
		serverUrl: {
			type: String,
			required: true
		}
	},
	mounted() {
		this.connectPixelStreamingSocket();
	},
	data() {
		return {
			pixelStreamingSocket: null,
			showWaitingMessage: true,
			timeouts: {
				socketDisconnect: null,
				maxWait: null
			}
		};
	},
	destroyed() {
		this.pixelStreamingSocket.removeEventListener('open', this.onSocketConnect);
		this.pixelStreamingSocket.removeEventListener('close', this.onSocketDisconnect);
		this.pixelStreamingSocket.removeEventListener('message', this.onSocketMessage);
		clearTimeout(this.timeouts.socketDisconnect);
		clearTimeout(this.timeouts.maxWait);
	},
	methods: {
		goToBoard() {
			this.$emit('go-to-board');
		},
		connectPixelStreamingSocket() {
			const ws = setup(this.$refs.player, this.serverUrl);

			ws.addEventListener('open', this.onSocketConnect);
			ws.addEventListener('close', this.onSocketDisconnect);
			ws.addEventListener('message', this.onSocketMessage);
			ws.addEventListener('error', this.onSocketError);

			this.pixelStreamingSocket = ws;
		},
		onSocketConnect() {
			console.log('Socket connected!');
		},
		onSocketError(error) {
			console.log('An error occurred', error);
		},
		onSocketMessage(event) {
			let msg = JSON.parse(event.data);

			if (msg.type === 'config') {
				this.showWaitingMessage = false;
			}
		},
		onSocketDisconnect(event) {
			if (event?.reason === 'Streamer is not connected') {
				this.showWaitingMessage = true;
				this.timeouts.socketDisconnect = setTimeout(() => this.connectPixelStreamingSocket(), 2000);
			} else if (event?.reason === '') {
				//	If there is not any reason apparently the pixel streaming server finished transmitting.
				this.goToBoard();
			}
		}
	}
};
</script>

<template>
	<div id='stream' class='w-100 h-100 text-center'>
		<div ref='player' id='player'/>
		<slot :show-waiting-message="showWaitingMessage">
		</slot>
	</div>
</template>
<style scoped>
#stream {
	width: 100%;
	position: absolute;
	z-index: 10;
}
</style>
